import { $ } from '@3pc/dom';
import aniScroll from 'modules/ani-scroll';

const backToTopBtn = $('.footer__back-to-top-button');

if (backToTopBtn) {
  backToTopBtn.addEventListener('click', () => {
    aniScroll(0, 1000, 'easeInOutQuad', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}
